import { Adapter, adapters } from 'wix-vod-adapters';

import settings from 'shared/settings';


const vodAdapterSettings = {
  apiUrl: settings.hosts.catalog,
  filesUrl: settings.hosts.files,
  uploadLimits: {
    secureVideo: 16106127360,
  },
};

let vodAdapter;
try {
  vodAdapter = new Adapter(adapters.VOD, vodAdapterSettings);
} catch (error) {
}

export default vodAdapter;



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/vod.js